module.exports = __webpack_public_path__ + "img/horizon.85fa265f.png";